import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  weekViewTimeScaleLayoutCustom: {
    height: 'auto',
    '& > :first-of-type': {
      height: '100%',
      width: 50,
      '& > :first-of-type': {
        '& > :first-of-type': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          '& > :first-of-type': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            height: '100%',
          },
        },
      },
    },
  },
}));

export const WeekViewTimeScaleLayoutCustom = (
  props: WeekView.TimeScaleLayoutProps
) => {
  const { classes, cx } = useStyles();
  return (
    <WeekView.TimeScaleLayout
      {...props}
      className={cx(classes.weekViewTimeScaleLayoutCustom, {})}
    ></WeekView.TimeScaleLayout>
  );
};
